import { useState } from "react";
import { useNavigate } from "react-router-dom";

export const useGetProjectsList = () => {

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const getProjects = async () => {
        setLoading(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/controllers/projects/getPList.php`, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                if (response.status === 401) {
                    // Handle unauthorized access
                    alert('Unauthorized access. Please login again.');
                    localStorage.clear();
                    navigate('/login');
                    return [];
                } else {
                    // Handle other error responses
                    throw new Error('Network response was not ok');
                }
            }

            let responseData;
            try {
                responseData = await response.json();
            } catch (error) {
                throw new Error('Error parsing JSON response');
            }

            if (responseData.success) {
                /*
                => responseData.projects (An Array of Objects)
                ----------------------------------------------
                [
                    {
                        "pId": 2,
                        "pName": "Project B",
                        "startDate": "2024-02-01",
                        "status": "In Progress",
                        "completedDate": null,
                        "estimatedHours": 15,
                        "pTypeId": 2,
                        "projectTypeName": "AMC",
                        "active": 1
                    }, {...}, {...}
                ]
                */
                return responseData.projects;
            } else {
                alert(responseData.error);
                return [];
            }
        } catch (error) {
            console.error('An error occurred in fetching projects:', error);
            alert('An error occurred. Please try again later.');
            return [];
        } finally {
            setLoading(false);
        }
    }
    return { getProjects, loading }
}
